import { Routes } from '@angular/router';
import { AppGuard } from './app.guard';

export const routes: Routes = [
  {
    path: 'home',
    canActivate: [AppGuard],
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'auth',
    loadComponent: () => import('./auth/auth.page').then((m) => m.AuthPage),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];
